var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.515 12C29.7637 12.0038 30.0087 12.08 30.2175 12.2263C30.5512 12.46 30.75 12.8425 30.75 13.25V40.75C30.75 41.435 30.1988 41.9912 29.5163 42H29.5H15.75C15.06 42 14.5 41.44 14.5 40.75C14.5 40.75 14.5 25.2912 14.5 20.0013C14.5 18.4238 15.4862 17.0162 16.9687 16.4762C20.6187 15.15 29.0725 12.075 29.0725 12.075C29.205 12.0275 29.3413 12.0025 29.4775 12H29.4962H29.515ZM33.25 22.2475L37.2275 23.9512C38.6062 24.5425 39.5 25.8988 39.5 27.3988V40.75C39.5 41.44 38.94 42 38.25 42H33.0363C33.175 41.6088 33.25 41.1888 33.25 40.75V22.2475ZM24.5162 33.25C25.1987 33.2412 25.75 32.685 25.75 32C25.75 31.31 25.19 30.75 24.5 30.75H20.75C20.06 30.75 19.5 31.31 19.5 32C19.5 32.69 20.06 33.25 20.75 33.25H24.5H24.5162ZM24.5162 28.25C25.1987 28.2412 25.75 27.685 25.75 27C25.75 26.31 25.19 25.75 24.5 25.75H20.75C20.06 25.75 19.5 26.31 19.5 27C19.5 27.69 20.06 28.25 20.75 28.25H24.5H24.5162ZM24.5162 23.25C25.1987 23.2412 25.75 22.685 25.75 22C25.75 21.31 25.19 20.75 24.5 20.75H20.75C20.06 20.75 19.5 21.31 19.5 22C19.5 22.69 20.06 23.25 20.75 23.25H24.5H24.5162Z",
    fill: "#B4B4B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.f0cce1ec23bcdd1bf5da182221f9ba87.svg";
export { ForwardRef as ReactComponent };